/**
 * Maintained by Sandon.
 */
export default {
  'zh-CN': {
    notChoose: '暂不选择',
    pleaseChoose: '请选择',
    search: '搜索'
  },
  'en': {
    notChoose: 'No selection for now',
    pleaseChoose: 'Please select',
    search: '搜索'
  }
}
